<template>
  <ul class="clearfix">
    <li class="cell" :style="{width: 100 / data.items.length + '%'}" v-for="item in data.items">
      <div class="s-total-data" :class="item.highlight ? 'ongoing' : ''">
        <span class="num">{{ item.value }}</span>
        <span class="name">{{ item.label }}</span>
      </div>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      data: {
        type: 'Object'
      }
    },
    name: 'column-config',
    typeCode: '1'
  }
</script>

<style scoped>
  .cell:first-child {
    padding-left: 0;
  }

  .cell:last-child {
    border-right: 0;
  }

  .cell:last-child .s-total-data {
    border-right: 0;
  }

  .cell {
    position: relative;
    text-align: center;
    float: left;
  }

  .s-total-data {
    border-right: 1px solid #eee;
  }

  .s-total-data.ongoing .num {
    color: #3b56ce;
  }

  .s-total-data.ongoing .name {
    color: #3b56ce;
    opacity: 0.8;
    filter: alpha(opacity=80);
  }

  .s-total-data .num {
    font-family: "Gill Sans", "Gill Sans MT", "Myriad Pro", "DejaVu Sans Condensed", Helvetica, Arial, "sans-serif";
    font-size: 30px;
    font-weight: 500;
    color: #565656;
  }

  .s-total-data span {
    display: block;
    line-height: 1;
  }

  .s-total-data .name {
    margin-top: 10px;
    font-size: 12px;
    color: #999;
  }

  .s-total-data span {
    display: block;
    line-height: 1;
  }
</style>



// WEBPACK FOOTER //
// src/custom/components/page/analyse/show/components/column-config.vue